<template>
  <span class="messenger-chat-message-info-compensator">
    <messenger-chat-message-info
      :message-time="messageTime"
      :status="status"
    />
  </span>
</template>

<script lang="ts" setup>
import type { MessengerMessageStatus } from '@widgets/messenger/types/chat/message'
import MessengerChatMessageInfo from '@widgets/messenger/components/messages/MessengerChatMessageInfo.vue'

const { messageTime, status } = defineProps<{
  messageTime: string // ISO, example: 2024-08-13T03:17:03+0000
  status?: MessengerMessageStatus
}>()
</script>

<style lang="scss" scoped>
.messenger-chat-message-info-compensator {
  padding-left: 8px;
  visibility: hidden;
}
</style>
